import React, { FC } from 'react';
import {NavLink, NavLinkProps} from 'react-bootstrap';
import styles from './YoPills.module.sass';


export const YoPillNavLink : FC<NavLinkProps & React.ComponentProps<'a'>> = ({className,  style, children, ...props}) => {
  return <NavLink {...props} className={`${styles.yoPillsNavLink} ${className ?? ""}`} style={style}>{children}</NavLink>
}
